import { Helmet } from "react-helmet-async";

const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://legacy-readiness.emergent.host").replace(/\/$/, "");
const DEFAULT_TITLE = "Legacy Wave | Discover Today. Protect Tomorrow.";
const DEFAULT_DESC = "What would you like help understanding today? Choose your pathway — Protect My Legacy, Protect My Family, Understand My Medicare, or the Complete Legacy Checkup™ — and take a quick, educational checkup from Legacy Wave Consulting.";

export default function SEO({ title, description, path = "", type = "website", jsonLd }) {
  const fullTitle = title ? `${title} | Legacy Wave` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content="Legacy Wave Consulting" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${SITE_URL}/og-social.png`} />
      <meta property="og:image:secure_url" content={`${SITE_URL}/og-social.png`} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Legacy Wave Consulting — Your Free Legacy Checkup. Discover Today. Protect Tomorrow." />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={`${SITE_URL}/og-social.png`} />
      <meta name="twitter:image:alt" content="Legacy Wave Consulting — Your Free Legacy Checkup. Discover Today. Protect Tomorrow." />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
